/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import styled from "@emotion/styled";


import HistoryIcon from "@material-ui/icons/AccessTime";

import DeleteIcon from "@material-ui/icons/Delete";
import RotateIcon from "@material-ui/icons/SettingsBackupRestore";
import ScaleIcon from "@material-ui/icons/PhotoSizeSelectLarge";
import AddIcon from "@material-ui/icons/Add";
import MoveIcon from "@material-ui/icons/OpenWith";
import EditIcon from "@material-ui/icons/TextFields";
import InitialIcon from "@material-ui/icons/FiberNew";
import ColorIcon from "@material-ui/icons/ColorLens";
import FormatIcon from "@material-ui/icons/TextFormat";

import ToolbarButton from "./../ToolbarButton";
import PerfectScrollbar from "react-perfect-scrollbar";

import t from "../../translations";

import { useStoreon } from "storeon/react";

const HistoryWrap = styled.div`
  position: absolute;
  z-index: 9999;
  bottom: 36px;
  background: #3b3b3b;
  padding: 5px;
  display: ${props => (props.visible ? "block" : "none")};
  min-width: 150px;
  height: 290px;
  > div {
    > ul {
      padding: 0;
      margin: 0;
      > li {
        user-select: none;
        display: flex;
        align-items: center;
        list-style: none;
        padding: 5px 10px;
        border-bottom: 1px solid #595959;
        color: #eee;
        cursor: pointer;
        &:hover {
          background: #444;
        }
        &.active {
          background: #555;
        }
        > svg {
          height: 19px;
          width: 19px;
        }
        > span {
          height: 22px;
          margin-left: 10px;
        }
      }
    }
  }
`;

const HistoryList = styled.ul`
  display: flex;
  flex-direction: column-reverse;
`;

const eventData = {
  initial: { name: t.initial, icon: <InitialIcon /> },
  "object:moved": { name: t.move, icon: <MoveIcon /> },
  "object:rotated": { name: t.rotate, icon: <RotateIcon /> },
  "object:scaled": { name: t.scale, icon: <ScaleIcon /> },
  "object:removed": { name: t.remove, icon: <DeleteIcon /> },
  "object:added": { name: t.add, icon: <AddIcon /> },
  "text:editing:exited": { name: t.edit, icon: <EditIcon /> },
  "text:color": { name: t.color, icon: <ColorIcon /> },
  "text:format": { name: t.format, icon: <FormatIcon /> }
};

const targetType = {
  "i-text": t.text,
  image: t.image
};

const HistoryContent = props => {
  const { visible } = props;
  const { canvas } = useStoreon("cachePool", "canvas", "isAdmin");
  const [history, setHistory] = useState([...canvas.DPE.history.history]);
  const [index, setIndex] = useState(canvas.DPE.history.index);

  useEffect(
    _ => {
      if (!canvas) return;
      canvas.on({
        "history:changed": e => {
          const { history, index } = e;
          setHistory(history.reverse());
          setIndex(index);
        }
      });
    },
    [canvas]
  );

  const handleHistoryClick = index => {
    canvas.DPE.history.applySnapshot(index);
    setIndex(index);
  };

  return (
    <HistoryWrap visible={visible}>
      <PerfectScrollbar>
        <HistoryList>
          {history.map((item, i) => {
            const eventName = eventData[item.event].name;
            const eventIcon = eventData[item.event].icon;
            const className = i === index ? "active" : "";
            const eventTraget = item.target ? targetType[item.target.type] : "";
            const onClick = _ => {
              handleHistoryClick(i);
            };
            return (
              <li key={i} onClick={onClick} className={className}>
                {eventIcon}
                <span>
                  {eventTraget} {eventName}
                </span>
              </li>
            );
          })}
        </HistoryList>
      </PerfectScrollbar>
    </HistoryWrap>
  );
};

const History = () => {
  const [isHistoryVisible, setIsHistoryVisible] = useState(false);

  return (
    <div className="deskpad-history">
      <ToolbarButton
        dark
        tooltip
        height={36}
        active={isHistoryVisible}
        onClick={_ => {
          setIsHistoryVisible(is => !is);
        }}
        vertical
        desc={t.history}
        icon={<HistoryIcon />}
      />
      <HistoryContent visible={isHistoryVisible} />
    </div>
  );
};

export default History;
